import apiClient from '../../../../api/apiClient';
import { useToast } from '../../../../context/ToastContext';

export function usePayrollActions(onSuccess: () => void) {
  const { showSuccess, showError } = useToast();

  const approvePayroll = async (id: number, payroll: any) => {
    if (!window.confirm('Approve payroll ini?')) return;
    try {
      await apiClient.put(`/hris/payroll/${id}`, {
        ...payroll,
        status: 'processed',
      });
      onSuccess();
      showSuccess('Payroll berhasil disetujui');
    } catch (error) {
      showError('Gagal approve payroll');
    }
  };

  const processPayment = async (id: number, payroll: any) => {
    if (!window.confirm('Tandai sebagai sudah dibayar?')) return;
    try {
      await apiClient.put(`/hris/payroll/${id}`, {
        ...payroll,
        status: 'paid',
        payment_date: new Date().toISOString().split('T')[0],
      });
      onSuccess();
      showSuccess('Status pembayaran berhasil diperbarui');
    } catch (error) {
      showError('Gagal update status pembayaran');
    }
  };

  return {
    approvePayroll,
    processPayment,
  };
}
